// extracted by mini-css-extract-plugin
export default {"Box":"InfobarPopover-module__Box--qtcHk","CircleOcticon":"InfobarPopover-module__CircleOcticon--yvGLn","success":"InfobarPopover-module__success--LF_X5"};